import MemberDetailsCard from './MemberDetailsCard'

export default MemberDetailsCard
